<template>
  <div class="head-index">
    <div class="flex-box between head-content">
      <div class="left flex-box">
        <div class="nav-item" v-for="(item, index) in navList" :key="index" @click="handlerNav(item)">
          {{ item.name }}
        </div>
      </div>
      <div class="right">
        <span v-if="loginStatus.status">
          你好<span>【{{ loginStatus.userName }}】</span
          ><span @click="handlerExit" class="c-p">【退出】 </span>
        </span>
        <span v-else class="c-p" @click="handlerLogin">
          登录
        </span>
        <span>客服电话：{{ hotLink.Contents }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    loginStatus: {
      type: Object,
      default: () => {},
    },
    hotLink: {
      type: Object,
      default: () => {},
    },
  },
  name: "head-index",
  data() {
    return {
      navList: [
        {
          name: "网校首页",
          link: () => window.location.origin,
        },
        {
          name: "网校课程",
          link: () => window.location.origin + '/course/taste',
        },
        {
          name: "在线题库",
          link: () => window.location.origin + '/tiku/exam/class',
        },
        {
          name: "会员中心",
          link: () => window.location.origin + '/uc/userinfo',
        },
      ],
    };
  },
  mounted() {},
  methods: {
    handlerNav(item) {
      window.open(item.link())
    },
    handlerExit() {
      localStorage.removeItem("usertoken");
      this.$emit("exit");
    },
    handlerLogin() {
      window.location.href =
        window.location.origin +
        "/uc/login?redirecturl=" +
        window.location.href;
    },
  },
};
</script>

<style lang="scss" scoped>
.head-index {
  background: #1628ab;
  .head-content {
    margin: 0 auto;
    width: 1200px;
    height: 42px;
    .left {
      font-size: 14px;
      .nav-item {
        font-weight: bold;
        color: #ffffff;
        margin-right: 49px;
        cursor: pointer;
      }
    }
    .right {
      font-size: 14px;
      font-weight: bold;
      color: #ffffff;
    }
  }
}
</style>
